<template>
  <Nav />
  <div class="container container-entidade">
    <div class="entidades-header align-left">
      <h1 class="h3 mb-3 poppins-light">
        Selecione o <span class="poppins-semibold">Município</span>
      </h1>
    </div>
    <div class="filter-container" v-if="entidades.length > 1">
      <input
        type="text"
        v-model="filterText"
        placeholder="Buscar municípios..."
        class="form-control"
      />
      <button class="btn btn-outline-secondary" @click="clearFilter">Limpar</button>
    </div>
    <div class="entidades-list">
      <ul class="list-group" v-if="filteredEntidades.length > 0">
        <li
          v-for="entidade in filteredEntidades"
          :key="entidade.codigo_siconfi"
          class="list-group-item"
        >
          <a href="#" @click.prevent="setContext(entidade.codigo_siconfi)">
            {{ entidade.uf }} -
            {{
              entidade.razao_social.replace("MUNICÍPIO DE ", "") +
              (entidade.demo ? " (DEMO)" : "")
            }}
            <i class="bi bi-arrow-right"></i>
          </a>
        </li>
      </ul>
      <p
        v-else
        class="text-center"
        style="font-size: 1.2rem; color: var(--azul-final)"
      >
        Nenhum município encontrado.
      </p>
    </div>
  </div>
</template>

<script>
import axiosApi from "@/axios";
import Nav from "@/components/Nav.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "SelecaoEntidades",
  data() {
    return {
      entidades: [],
      filterText: "", // Adicionado para armazenar o texto do filtro
    };
  },
  computed: {
    ...mapState(["user", "isMunicipioChangeable"]),
    filteredEntidades() {
      const filtered = this.entidades.filter((entidade) => {
        const searchText = this.filterText.toLowerCase();
        const textToFilter = `${entidade.uf} - ${
          entidade.razao_social.replace("MUNICÍPIO DE ", "") +
          (entidade.demo ? " (DEMO)" : "")
        }`;

        return textToFilter.toLowerCase().includes(searchText);
      });
      console.log(filtered);
      return filtered;
    },
  },
  async created() {
    try {
      await this.validateToken();
      const responseUsersEntidades = await axiosApi.get(
        `/api/users/${this.user.email}/entidades`,
        { withCredentials: true }
      );
      this.entidades = responseUsersEntidades.data.data;

      if (this.entidades.length === 1) {
        this.setContext(this.entidades[0].codigo_siconfi);
        this.$store.commit('setIsMunicipioChangeable', false);
        return;
      }
      
      this.$store.commit('setIsMunicipioChangeable', true);
      this.entidades.sort((a, b) => {
        if (a.uf === b.uf) {
          return a.cidade.localeCompare(b.cidade);
        }
        return a.uf.localeCompare(b.uf);
      });
    } catch (error) {
      console.log(error);
      this.$router.push("/login");
    }
  },
  methods: {
    ...mapActions(["validateToken"]),
    async setContext(codigo_siconfi) {
      try {
        const response = await axiosApi.post(
          `/api/users/${this.user.email}/entidades/${codigo_siconfi}`,
          {},
          { withCredentials: true }
        );

        if (response.data.success) {
          this.$router.push("/");
        }
      } catch (error) {
        console.error(error);
      }
    },
    clearFilter() {
      this.filterText = "";
    },
  },
  components: {
    Nav,
  },
};
</script>

<style>
.container-entidade {
  display: flex;
  flex-direction: column;
  margin-top: 0;
}

.entidades-list {
  margin: 0 auto;
  width: 100%;
}

.entidades-list ul {
  list-style-type: none;
  padding: 0;
  /* min-width: 800px; */
}

.entidades-list ul li a {
  /* background-color: aqua; */
  padding: 10px;
  display: flex;
  width: 100%;
  color: var(--azul-final);
  transition: background-color 0.5s;
  font-size: 1.2rem;
}
.entidades-list ul li a i {
  right: 15px;
  position: absolute;
}
.entidades-list ul li a:hover {
  background-color: var(--azul-claro);
  color: white;
  font-weight: 600;
}

.entidades-list ul li {
  padding: 0;
}

.filter-container {
  width: 100%;
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
</style>
